type BfcacheWindow = Pick<Window, 'addEventListener' | 'removeEventListener'> & {
  location: Pick<Location, 'reload'>;
};

export const registerBfcacheReload = (win: BfcacheWindow = globalThis as unknown as BfcacheWindow) => {
  const handler = (event: PageTransitionEvent) => {
    if (event.persisted === true) {
      win.location.reload();
    }
  };
  win.addEventListener('pageshow', handler);
  return () => win.removeEventListener('pageshow', handler);
};
